import TextControls from './TextControls';

/**
 * The bounds for the lines of text - stays consistent regardless of string character height
 */
export default class TextLineControls extends TextControls {
  getX() {
    return this.textObject.x;
  }

  getY() {
    return this.textObject.y;
  }

  getWidth() {
    return this.textObject.foreground.text
      ? this.textObject.foreground.width
      : 0;
  }

  getHeight() {
    return this.textObject.fontHeight * this.textObject.numLines;
  }
}
